module.exports = __webpack_public_path__ + "static/apply.9b434099.svg";